module.exports = __webpack_public_path__ + "static/media/S2N10-1.6bf5a365.svg";